import { render, staticRenderFns } from "./LeadAppointment.vue?vue&type=template&id=1506b98e"
import script from "./LeadAppointment.vue?vue&type=script&lang=js"
export * from "./LeadAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports